import { InstitutionEnrolmentsState } from './state';
import { ReduxAction } from '../actions';

export const INITIAL_STATE: InstitutionEnrolmentsState = {};

export const InstitutionEnrolments = (
  state: InstitutionEnrolmentsState = INITIAL_STATE,
  action: ReduxAction
): InstitutionEnrolmentsState => {
  switch (action.type) {
    case 'SET_INSTITUTION_ENROLMENT': {
      const { institutionEnrolment } = action;
      const { path } = institutionEnrolment;

      return {
        ...state,
        [path]: institutionEnrolment,
      };
    }
    default:
      return state;
  }
};
